import React, { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";
import BtnDelete from "../../Commons/Buttons/BtnDelete";
import BtnSave from "../../Commons/Buttons/BtnSave";
import { Button, Divider, Row, Col } from "antd";
import { DeleteFilled } from "@ant-design/icons";
import TextField from "../../Commons/Forms/TextField";
import TextArea from "../../Commons/Forms/TextArea";
import NumberInputV2 from "../../Commons/Forms/NumberInputV2";

export default function AdjustPrescriptionModal({
  show,
  onHide,
  onSubmit,
  prescription,
  prescriptionDetails,
  setPrescriptionDetails,
  isClicked,
}) {
  const handleChange = (e, rowId) => {
    const { name, value } = e.target;
    var _prescriptionDetails = [...prescriptionDetails];

    _prescriptionDetails[rowId][name] = value;

    setPrescriptionDetails(() => _prescriptionDetails);
  };

  const handleDelete = (rowId) => {
    var _prescriptionDetails = [...prescriptionDetails];
    _prescriptionDetails.splice(rowId, 1);
    setPrescriptionDetails(() => _prescriptionDetails);
  };
  return (
    <Modal show={show} onHide={onHide} size="xl">
      <Modal.Header closeButton>
        <Modal.Title className="form-title">Adjust Prescription</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {prescriptionDetails?.map((p, index) => (
          <div key={p.id}>
            <Row gutter={[16, 0]}>
              <Col md={24} lg={12}>
                <TextField
                  required
                  id={`generic_` + p.id}
                  name="generic"
                  formLabel={`Generic`}
                  size={`sm`}
                  value={p.generic || ""}
                  onChange={(e) => handleChange(e, index)}
                  disabled={isClicked}
                />
              </Col>
              <Col md={24} lg={12}>
                <TextField
                  id={`brand_` + p.id}
                  name="brand"
                  formLabel={`Brand`}
                  size={`sm`}
                  value={p.brand || ""}
                  onChange={(e) => handleChange(e, index)}
                  disabled={isClicked}
                />
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col md={24} lg={12}>
                <TextField
                  id={`dosage_` + p.id}
                  name="dosage"
                  formLabel={`Dosage`}
                  value={p.dosage || ""}
                  onChange={(e) => handleChange(e, index)}
                  disabled={isClicked}
                />
              </Col>
              <Col md={24} lg={12}>
                <TextField
                  required
                  id={`preparation_` + p.id}
                  name="preparation"
                  formLabel={`Preparation`}
                  value={p.preparation || ""}
                  onChange={(e) => handleChange(e, index)}
                  disabled={isClicked}
                />
              </Col>
            </Row>
            {/* <Row gutter={[16,0]}>
                <Col md={24} lg={12}>
                  <TextField
                    id={`form_` + p.id}
                    name="form"
                    formLabel={`Form`}
                    value={p.form || ""}
                    onChange={(e) => handleChange(e, index)}
                    disabled={isClicked}
                  />
                </Col>
                <Col md={24} lg={12}>
                  <TextField
                    id={`route_` + p.id}
                    name="route"
                    formLabel={`Route`}
                    value={p.route || ""}
                    onChange={(e) => handleChange(e, index)}
                    disabled={isClicked}
                  />
                </Col>
              </Row> */}
            <Row gutter={[16, 0]}>
              {/* <Col md={24} lg={12}>
                <TextField
                  id={`frequency_` + p.id}
                  name="frequency"
                  formLabel={`Frequency`}
                  value={p.frequency || ""}
                  onChange={(e) => handleChange(e, index)}
                  disabled={isClicked}
                />
              </Col> */}
              <Col md={24} lg={12}>
                <NumberInputV2
                  id={`quantity_` + p.id}
                  name="quantity"
                  formLabel={`Quantity`}
                  value={p.quantity || ""}
                  onChange={(e) => handleChange(e, index)}
                  disabled={isClicked}
                />
              </Col>
              <Col md={24} lg={12}>
                <TextField
                  id={`duration_` + p.id}
                  name="duration"
                  formLabel={`Duration`}
                  value={p.duration || ""}
                  onChange={(e) => handleChange(e, index)}
                  disabled={isClicked}
                />
              </Col>
            </Row>
            {/* <Row gutter={[16, 0]}>
              <Col md={24} lg={12}>
                <TextField
                  id={`timing_` + p.id}
                  name="timing"
                  formLabel={`Timing`}
                  value={p.timing || ""}
                  onChange={(e) => handleChange(e, index)}
                  disabled={isClicked}
                />
              </Col>
            </Row> */}
            <Row gutter={[16, 0]}>
              <Col md={24}>
                <TextField
                  id={`instruction_` + p.id}
                  name="instruction"
                  formLabel={`Instruction`}
                  value={p.instruction || ""}
                  onChange={(e) => handleChange(e, index)}
                  disabled={isClicked}
                />
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col md={24}>
                <TextArea
                  id={`note_` + p.id}
                  name="note"
                  formLabel={`Notes`}
                  size={`sm`}
                  value={p.note || ""}
                  onChange={(e) => handleChange(e, index)}
                  disabled={isClicked}
                />
              </Col>
            </Row>
            {prescriptionDetails?.length !== 1 && (
              <div className="text-end mt-2">
                <Button
                  danger
                  type="text"
                  icon={<DeleteFilled />}
                  onClick={() => handleDelete(index)}
                  disabled={isClicked}
                />
              </div>
            )}
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <BtnDelete label={`Close`} onClick={onHide} isClicked={isClicked} />
        <BtnSave
          label={`Add Prescription`}
          onClick={() => onSubmit(prescriptionDetails)}
          isClicked={isClicked}
          disabled={
            prescriptionDetails[0]?.generic === "" ||
            prescriptionDetails[0]?.preparation === ""
          }
        />
      </Modal.Footer>
    </Modal>
  );
}
